import fetchApi from "../fetchApi";
export const GetServiceConfig = async () => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(`auth/service-configuration`, options, false);
};
